import { render, staticRenderFns } from "./ScanLogin.vue?vue&type=template&id=56dd689e&scoped=true"
import script from "./ScanLogin.vue?vue&type=script&lang=js"
export * from "./ScanLogin.vue?vue&type=script&lang=js"
import style0 from "./ScanLogin.vue?vue&type=style&index=0&id=56dd689e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56dd689e",
  null
  
)

export default component.exports